import { Lang } from '@jooxter/api';

export const getJooxterLanguageSubdomain = (): Lang | undefined => {
  if (!window?.location) {
    return void 0;
  }

  const subdomain = window.location.origin.replace('https://', '').split('.')[0];

  if (isUserLang(subdomain)) {
    return subdomain;
  }

  return void 0;
};

export const isUserLang = (subdomain: string): subdomain is Lang => {
  return Object.values<string>(Lang).includes(subdomain);
};
